import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth, isProUser } from '../../lib/auth';
import { Menu, X } from 'lucide-react';

function scrollTo(id, navigate) {
  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  } else {
    navigate(`/#${id}`);
  }
}

export default function Navbar() {
  const { user, profile, signOut } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [userMenuOpen, setUserMenuOpen] = useState(false);

  async function handleSignOut() {
    await signOut();
    navigate('/');
  }

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <Link to="/" className="navbar-logo">
          <img src="/logo-icon.svg" alt="IndiAds" width="28" height="28" style={{borderRadius:'7px'}} />
          <span className="logo-text">Indi<span style={{color:'#D4590A'}}>Ads</span></span>
        </Link>

        <div className="navbar-links">
          {!user ? (
            <>
              <a href="/#features" className="nav-link" onClick={e => { e.preventDefault(); scrollTo('features', navigate); }}>Features</a>
              <a href="/#pricing" className="nav-link" onClick={e => { e.preventDefault(); scrollTo('pricing', navigate); }}>Pricing</a>
              <a href="/#testimonials" className="nav-link" onClick={e => { e.preventDefault(); scrollTo('testimonials', navigate); }}>Reviews</a>
            </>
          ) : (
            <>
              <Link to="/library" className={`nav-link${isActive('/library') ? ' nav-link-active' : ''}`}>Library</Link>
              <Link to="/dashboard" className={`nav-link${isActive('/dashboard') ? ' nav-link-active' : ''}`}>Saved</Link>
              <a href="/#pricing" className="nav-link" onClick={e => { e.preventDefault(); scrollTo('pricing', navigate); }}>Pricing</a>
            </>
          )}
        </div>

        <div className="navbar-actions">
          {!user ? null : (
            <div className="user-menu-wrap">
              <button className="user-avatar-btn" onClick={() => setUserMenuOpen(!userMenuOpen)}>
                <div className="user-avatar">
                  {profile?.avatar_url
                    ? <img src={profile.avatar_url} alt="" />
                    : <span>{(profile?.full_name || user.email || 'U')[0].toUpperCase()}</span>
                  }
                </div>
                <span className="user-name">{profile?.full_name?.split(' ')[0] || 'You'}</span>
                {isProUser(profile) && <span className="plan-badge">Pro</span>}
              </button>
              {userMenuOpen && (
                <div className="user-dropdown">
                  <div className="user-dropdown-header">
                    <p className="dropdown-name">{profile?.full_name || user.email}</p>
                    <p className="dropdown-email">{user.email}</p>
                  </div>
                  <div className="dropdown-divider" />
                  <Link to="/library" className="dropdown-item" onClick={() => setUserMenuOpen(false)}>Library</Link>
                  <Link to="/dashboard" className="dropdown-item" onClick={() => setUserMenuOpen(false)}>Saved Ads</Link>
                  <Link to="/settings" className="dropdown-item" onClick={() => setUserMenuOpen(false)}>Settings</Link>
                  {profile?.role === 'admin' && (
                    <Link to="/admin" className="dropdown-item" onClick={() => setUserMenuOpen(false)}>Admin</Link>
                  )}
                  <div className="dropdown-divider" />
                  <button className="dropdown-item dropdown-item-danger" onClick={handleSignOut}>Sign out</button>
                </div>
              )}
            </div>
          )}
        </div>

        <button className="navbar-mobile-btn" onClick={() => setMenuOpen(!menuOpen)} aria-label={menuOpen ? 'Close menu' : 'Open menu'}>
          {menuOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {menuOpen && (
        <div className="navbar-mobile-menu">
          {!user ? (
            <>
              <a href="/#pricing" className="mobile-nav-link" onClick={e => { e.preventDefault(); setMenuOpen(false); scrollTo('pricing', navigate); }}>Pricing</a>
              <Link to="/signin" className="mobile-nav-link" onClick={() => setMenuOpen(false)}>Sign in</Link>
              <Link to="/signup" className="btn btn-primary" style={{margin: '8px 16px'}} onClick={() => setMenuOpen(false)}>Try For Free Now</Link>
            </>
          ) : (
            <>
              <Link to="/library" className="mobile-nav-link" onClick={() => setMenuOpen(false)}>Library</Link>
              <Link to="/dashboard" className="mobile-nav-link" onClick={() => setMenuOpen(false)}>Saved</Link>
              <Link to="/settings" className="mobile-nav-link" onClick={() => setMenuOpen(false)}>Settings</Link>
              <button className="mobile-nav-link" style={{color:'#ef4444'}} onClick={() => { setMenuOpen(false); handleSignOut(); }}>Sign out</button>
            </>
          )}
        </div>
      )}
    </nav>
  );
}
